import React, { useEffect } from 'react';
import { useFormik } from 'formik';
import { Link as RouterLink, useNavigate } from 'react-router-dom';
import { useActions } from '../../../hooks/useAction';
import { useTypedSelector } from '../../../hooks/useTypesSelector';
import { LoadingButton } from '@mui/lab';
import { Container, Avatar, Typography, TextField, Button, Box } from '@mui/material';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import { LoginSchema } from '../helpers/yup';

export const Login = () => {
  const { login } = useActions();
  const { loading, isAuthorized } = useTypedSelector((state) => state.auth);
  const navigate = useNavigate();

  const formik = useFormik({
    initialValues: {
      email: '',
      password: '',
    },
    validationSchema: LoginSchema,
    onSubmit: (values) => {
      login(values);
    },
  });

  useEffect(() => {
    if (isAuthorized) {
      navigate('/');
    }
  }, [isAuthorized, navigate]);

  return (
    <Box>
      <Container maxWidth="xs">
        <Box
          sx={{
            paddingTop: 3,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
          }}
        >
          <Avatar sx={{ m: 1, bgcolor: 'secondary.main' }}>
            <LockOutlinedIcon />
          </Avatar>
          <Typography component="h1" variant="h5">
            Вход
          </Typography>
          <Box component="form" onSubmit={formik.handleSubmit} noValidate sx={{ mt: 1 }}>
            <TextField
              margin="normal"
              required
              fullWidth
              id="email"
              label="Почта"
              name="email"
              autoComplete="email"
              autoFocus
              onChange={formik.handleChange}
              error={formik.touched.email && Boolean(formik.errors.email)}
              helperText={formik.touched.email && formik.errors.email}
            />
            <TextField
              margin="normal"
              required
              fullWidth
              name="password"
              label="Пароль"
              type="password"
              onChange={formik.handleChange}
              id="password"
              error={formik.touched.password && Boolean(formik.errors.password)}
              helperText={formik.touched.password && formik.errors.password}
              autoComplete="current-password"
            />
            {loading ? (
              <LoadingButton size="large" variant="contained" loading={loading} fullWidth={true}>
                Зарегистрироваться
              </LoadingButton>
            ) : (
              <Button
                type="submit"
                variant="contained"
                fullWidth={true}
                disableElevation={true}
                color="primary"
                sx={{
                  marginTop: 1,
                  marginBottom: 1,
                }}
              >
                Войти
              </Button>
            )}
            <Box sx={{ display: 'inline-flex', alignItems: 'baseline' }}>
              <Typography> Еще нет аккаунта? </Typography>
              <Button component={RouterLink} to="/registration" variant="text">
                Зарегистрироваться
              </Button>
            </Box>
          </Box>
        </Box>
      </Container>
    </Box>
  );
};
